export const TEXT = {
    INFO: "Oops! Something went wrong.",
    BACK_LINK_LABEL: "GO BACK",
};
